import axios from 'axios';
import {
  ENQUIRY_CREATE_REQUEST, ENQUIRY_CREATE_SUCCESS, ENQUIRY_CREATE_FAIL,
  ENQUIRY_LIST_REQUEST, ENQUIRY_LIST_SUCCESS, ENQUIRY_LIST_FAIL,
} from '../constants/enquiryConstants';

const baseUrl = process.env.REACT_APP_API_URL;

export const createEnquiry = (payload) => async (dispatch) => {
  try {
    dispatch({ type: ENQUIRY_CREATE_REQUEST });

    const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
    const config = isFormData
      ? {}
      : { headers: { 'Content-Type': 'application/json' } };

    const { data } = await axios.post(`${baseUrl}/enquiries`, payload, config);
    dispatch({ type: ENQUIRY_CREATE_SUCCESS, payload: data.enquiry });
    return data.enquiry;
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({
      type: ENQUIRY_CREATE_FAIL,
      payload: message,
    });
    throw new Error(message);
  }
};

// ADMIN: list enquiries (unchanged)
export const listEnquiries = (params = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: ENQUIRY_LIST_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        ...(userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {})
      },
      params,
    };

    const { data } = await axios.get(`${baseUrl}/enquiries`, config);
    dispatch({ type: ENQUIRY_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: ENQUIRY_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};
export const updateEnquiry = (id, payload) => async (dispatch, getState) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const { userLogin: { userInfo } } = getState();
  try {
    const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
    const headers = {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {})
    };
    const { data } = await axios.put(
      `${baseUrl}/enquiries/${id}`,
      payload,
      { headers }
    );
    // optional: you can dispatch a dedicated UPDATE_SUCCESS if you have reducers for it
    return data.enquiry;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const deleteEnquiry = (id) => async (dispatch, getState) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const { userLogin: { userInfo } } = getState();
  try {
    await axios.delete(
      `${baseUrl}/enquiries/${id}`,
      { headers: { ...(userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {}) } }
    );
    // optional: dispatch a DELETE_SUCCESS; here we’ll just refresh the list from the component.
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
